import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import translations from './translations';
import resizeImageUrl from '@afosto/utils/resizeImageUrl';

const ProductLine = ({ item, avatarSize }) => (
  <Box display="flex">
    <Avatar
      src={resizeImageUrl(item?.product?.image, avatarSize)}
      style={{ height: avatarSize, width: avatarSize }}
    />
    <Box px={2}>
      <Typography variant="body2" style={{ fontWeight: 500 }}>
        {item?.description}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <FormattedMessage
          {...translations.properties.articleNumber}
          values={{ number: item?.sku }}
        />
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <FormattedMessage
          {...translations.properties.eanNumber}
          values={{ number: item?.ean ?? item?.product?.ean }}
        />
      </Typography>
    </Box>
  </Box>
);

ProductLine.propTypes = {
  item: PropTypes.object,
  avatarSize: PropTypes.number,
};

ProductLine.defaultProps = {
  item: {},
  avatarSize: 65,
};

export default ProductLine;
